type GridOptions = {
  withLegend?: boolean;
  hasTitle?: boolean;
  // containLabel accounts for tick-label width but not axis *name* width, so callers with a
  // rotated y-axis name must pass its measured extent (nameGap + text thickness) here or it
  // clips at the chart edge.
  yAxisLeft?: number;
};

export const buildGridConfig = ({ withLegend = false, hasTitle = false, yAxisLeft = 16 }: GridOptions = {}) => ({
  left: yAxisLeft,
  right: 40,
  top: hasTitle ? 40 : 16,
  bottom: withLegend ? 56 : 32,
  containLabel: true,
});
